import React, { useEffect, useState } from 'react';
import { ConfirmOffcanvas } from '../../../components/CustomModal/ConfirmOffcanvas';
import { FormField, FormFieldCheck } from '../../../components/Form/FormField';
import { Button, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { candidateSchema, defaultCandidateFields } from './candidateSchema';
import * as SubmissionsAPI from '../../../api/SubmissionsAPI';
import { handleApiError } from '../../../common/errorHandler';
import { toast } from 'react-toastify';

const AddEditCandidate = ({
  addEditCandidateModal,
  resetCandidateModal,
  handleDeleteCandidate,
  handleSavingCandidate,
}) => {
  const { id, submissionId, shift, show, title, data } = addEditCandidateModal;
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    setError,
    reset,
    setFocus,
    handleSubmit,
    formState: { errors: candidateErrors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(candidateSchema),
    defaultValues: defaultCandidateFields,
  });

  const fetchCandidate = async () => {
    setIsLoading(true);
    try {
      const response = await SubmissionsAPI.getCandidateById(id);
      const data = response?.data;
      if (data) {
        console.log('🚀 ~ fetchCandidate ~ data:', data);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const formSubmit = async (formData) => {
    formData = {
      ...formData,
      iris_checked: Boolean(formData.iris_checked),
      iris_verified: Boolean(formData.iris_verified),
      exam_day_id: submissionId,
      shift,
    };
    setIsLoading(true);
    try {
      let requestPromise;
      let successMessage;

      if (id) {
        requestPromise = SubmissionsAPI.updateCandidate(id, formData);
        successMessage = 'Candidate updated successfully.';
        handleSavingCandidate('AddEditCandidate');
      } else {
        requestPromise = SubmissionsAPI.createCandidate(formData);
        successMessage = 'Candidate added successfully.';
        handleSavingCandidate('AddEditCandidate');
      }

      await requestPromise.then((res) => {
        resetCandidateModal(true);
        toast.success(successMessage);
      });
    } catch (error) {
      handleApiError(error, setError);
    } finally {
      setIsLoading(false);
    }
  };
  const OPTIONS1 = [{ label: 'IRIS Checked', value: true }];
  const OPTIONS2 = [{ label: 'IRIS Verified', value: true }];

  useEffect(() => {
    setTimeout(() => {
      setFocus('name');
    }, 0);
    if (!data) return; // Avoid running if data is undefined/null

    reset({
      name: data.name,
      registration_no: data.registration_no,
      error_code: data.error_code,
      reason: data.reason,
      iris_checked: data.iris_checked,
      iris_verified: data.iris_verified,
    });
  }, [data, reset]);
  return (
    <ConfirmOffcanvas
      isLoading={isLoading}
      show={show}
      title={title}
      onHide={() => {
        resetCandidateModal(false);
      }}
      bodyClass='p-3'
    >
      <Row className='row-cards mb-3'>
        <FormField
          label='Name*'
          name='name'
          type='text'
          placeholder='Enter Name'
          error={candidateErrors.name}
          {...{ register }}
          autoFocus={true}
        />
        <FormField
          label='Registration No.*'
          name='registration_no'
          type='text'
          placeholder='Enter Registration No.'
          error={candidateErrors.registration_no}
          {...{ register }}
        />
        <FormField
          label='Error Code* (With Reason of Error)'
          name='error_code'
          type='text'
          size='12'
          placeholder='Code or N/A if Not Applicable'
          error={candidateErrors.error_code}
          {...{ register }}
        />
        <FormField
          as='textarea'
          rows={3}
          isLabel={false}
          name='reason'
          placeholder='Enter Reason'
          {...{ register }}
        />
        <FormFieldCheck
          isLabel={false}
          name={`iris_checked`}
          options={OPTIONS1}
          type='checkbox'
          size='12'
          checkClass='my-0'
          {...{ register }}
        />
        <FormFieldCheck
          isLabel={false}
          name={`iris_verified`}
          register={register}
          options={OPTIONS2}
          type='checkbox'
          size='12'
          className='mt-0'
          checkClass='my-0'
          {...{ register }}
        />
      </Row>
      <Row className='g-3'>
        <Col>
          <Button
            type='button'
            className='w-100'
            onClick={() => handleSubmit(formSubmit)()}
          >
            Save
          </Button>
        </Col>
        {id && (
          <Col>
            <Button
              variant='danger'
              type='button'
              className='w-100'
              onClick={() => handleDeleteCandidate(id)}
            >
              Delete
            </Button>
          </Col>
        )}
      </Row>
    </ConfirmOffcanvas>
  );
};

export default AddEditCandidate;
